export const SEARCH_PARAM_KEYS = {
  ASK_WHY_SURVEY_ID: 'ask_why_survey_id',
  COMPARE_BY: 'compare_by',
  DISPLAY_AS: 'display_as',
  QUESTION_OPTION: 'option_ids',
  QUOTA_GROUP: 'group_ids',
};

export const SURVEY_QUESTION_FIELDS_TO_MERGE = [
  'answers',
  'caption',
  'image',
  'questionSourceId',
  'showConceptImage',
  'text',
];
